"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rocca-santa-maria": {
    "055aeafe": [{
      "hkey": "12451905",
      "slug": "acquaratola",
      "name": "Acquaratola",
      "primary": true,
      "skipSearch": false
    }],
    "acquatarola": [{
      "hkey": "12451905",
      "slug": "acquaratola",
      "name": "Acquaratola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2a7c4e08": [{
      "hkey": "db976efa",
      "slug": "faiete-cona-faiete",
      "name": "Faiete-Cona Faiete",
      "primary": true,
      "skipSearch": false
    }],
    "faiete": [{
      "hkey": "db976efa",
      "slug": "faiete-cona-faiete",
      "name": "Faiete-Cona Faiete",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4747b182": [{
      "hkey": "7b973b00",
      "slug": "rocca-santa-maria",
      "name": "Rocca Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "tavolero": [{
      "hkey": "7b973b00",
      "slug": "rocca-santa-maria",
      "name": "Rocca Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;